import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['element', 'textElement'];

  static values = {
    toggledClassName: { type: String, default: 'hidden' },
    updateText: { type: String, default: '' },
  };

  toggle () {
    this.elementTarget.classList.toggle(this.toggledClassNameValue);

    const oldValue = this.textElementTarget.text;
    this.textElementTarget.text = this.updateTextValue;
    this.updateTextValue = oldValue;
  }
}
